import { getEnv } from "@/env";

export const LMS_USER_DATA_INIT_API_URL = `${getEnv("NEXT_PUBLIC_LMS_BASE_URL")}/api/learner_home/init/`;

export const LMS_USER_DATA_CACHE_COOKIE = "edx-lms-user-data-cache";
